export default [
  {
    _name: 'CSidebarNav',
    _children: [
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Summary',
      //   to: '/dashboard',
      //   icon: 'cil-speedometer'
      // },
      {
        _name: 'CSidebarNavItem',
        name: 'Subscribe/Buy',
        to: '/buysubscribe',
        icon: 'cil-speedometer'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Adjust Current Plan',
        to: '/adjustplan',
        icon: 'cil-av-timer'
      },
      // {
      //   _name: 'CSidebarNavTitle',
      //   _children: ['Admin']
      // },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Account Details',
        route: '/account',
        icon: 'cil-chart-pie',
        items: [
          {
            name: 'My Info',
            to: '/account/info'
          },
          {
            name: 'Usage',
            to: '/account/usage'
          },
          {
            name: 'Devices',
            to: '/account/devices'
          }, 
          {
            name: 'Events',
            to: '/account/events'
          },
          // {
          //   name: 'Entitlements',
          //   to: '/account/entitlements'
          // },
          {
            name: 'Notices',
            to: '/account/notices'
          }
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Logout',
        icon: 'cil-av-timer',
        _class: 'sidebar-logout-btn'
      },
      {
        _name: 'CSidebarNavDivider',
        _class: 'm-2'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Extras']
      },      
      {
        _name: 'CSidebarNavItem',
        name: 'SoldierNET',
        href: 'http://www.soldiernet.co.uk',
        icon: { name: 'cil-tags', class: 'text-white' },
        target: '_blank'
      },
    ]
  }
]